import React, { useEffect, useMemo, useState } from 'react';
import { Guide } from '@/pages/home/components/Guide';
import { getLocale, useDispatch, useIntl, useLocation, useSelector } from 'umi';
import guideImg_1_1_cn from '@/pages/dashboard/assets/images/guide/cn/guide-dbd-feature1-1.png';
import guideImg_1_1_en from '@/pages/dashboard/assets/images/guide/en/guide-dbd-feature1-1.png';
import guideImg_1_2_cn from '@/pages/dashboard/assets/images/guide/cn/guide-dbd-feature1-2.png';
import guideImg_1_2_en from '@/pages/dashboard/assets/images/guide/en/guide-dbd-feature1-2.png';
import {
  DASHBOARD_GUIDE_BOX_LIST1,
  DASHBOARD_GUIDE_BOX_LIST1_PATH, DASHBOARD_GUIDE_HIDE,
} from '@/pages/home/components/GuideModule/GuideDashboardBox';
import { GUIDE_TYPE_DASHBOARD_OVERVIEW, GUIDE_SYS_DASHBOARD } from '@/pages/home/models/guide';
import { storage } from '@/utils/utils';

import './index.scss';
const GuideOverViewDaily = () => {
  const [currentGuideStep, setCurrentGuideStep] = useState(-3);
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isEn = locale === 'en-US';
  const dispatch = useDispatch();
  const { guideType, userInfo } = useSelector((state: any) => {
    const { guide: { guideType }, home: { userInfo } } = state;
    return {
      guideType,
      userInfo
    }
  });

  // 注意下面两个useEffect不要合并到一起，不然会出现：从头部导航进入新手引导，点击到下一步时，关闭按钮无法关闭，而是返回到第一步
  useEffect(() => {
    if (guideType === GUIDE_TYPE_DASHBOARD_OVERVIEW) {
      setCurrentGuideStep(0);
    }
  }, [guideType]);

  useEffect(()=>{
    const list = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST1) || [];
    const guideHide = storage.getLocalStorageItem(DASHBOARD_GUIDE_HIDE);
    if (userInfo?.openid && !list.includes(userInfo.openid) && !guideHide) {
      setCurrentGuideStep(0);
    }
  },[userInfo])

  // 流程完成后保存至local storage
  const updateGuideCompletionStatus = () => {
    if (userInfo.openid) {
      const list = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST1) || [];
      !list?.includes(userInfo.openid) && list.push(userInfo.openid);
      storage.setLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST1, list);
    }
  };

  const onFinished = () => {
    updateGuideCompletionStatus();

    dispatch({
      type: 'guide/showDashboardGuideModule',
      payload: true,
    });
  }

  const onCloseStep = () => {
    updateGuideCompletionStatus();
    
    dispatch({
      type: 'guide/save',
      payload: {
        guideSys: GUIDE_SYS_DASHBOARD,
        guideType: '',
      },
    });
  }

  const steps = useMemo(() => {
      const steps = [
            {
              highlightElements: [{element: document.getElementsByClassName('menu-overview-daily')?.[0]}],
              element: () =>
                document.getElementById('overview-daily-key-metrics'),
              title: formatMessage({id:'guide_overview_daily_step1_title'}),
              subtitle: formatMessage({id:'guide_overview_daily_step1_subtitle'}),
              description: formatMessage({id:'guide_overview_daily_step1_description'}),
              placement: 'top-start',
              bubbleStyle: { left: '200px' },
              extImage: {
                image: isEn ? guideImg_1_1_en :  guideImg_1_1_cn,
                placement: 'bottom-start',
                style: { width: '417px', left: '200px', position: 'relative' },
              },
            },
            {
              highlightElements: [{element: document.getElementsByClassName('menu-overview-daily')?.[0]}],
              element: () =>
                document.getElementsByClassName(
                  'js-overview-table-dimension',
                )?.[0],
              title: formatMessage({id:'guide_overview_daily_step2_title'}),
              subtitle: formatMessage({id:'guide_overview_daily_step2_subtitle'}),
              description: formatMessage({id:'guide_overview_daily_step2_description'}),
              placement: 'bottom-start'
            },
            {
              highlightElements: [{element: document.getElementsByClassName('menu-overview-daily')?.[0]}],
              element: () =>
                document.getElementsByClassName(
                  'js-overview-table-setting',
                )?.[0],
                title: formatMessage({id:'guide_overview_daily_step3_title'}),
                subtitle: formatMessage({id:'guide_overview_daily_step3_subtitle'}),
                description: formatMessage({id:'guide_overview_daily_step3_description'}),
              placement: 'left-start',
            },
          ]
    return steps;
  }, [currentGuideStep,locale]);

  return (
    // finishText 根据中英文调整
    <Guide
      current={currentGuideStep}
      onCurrentChange={(
        current: number,
        context: { from: 'start' | 'back' | 'next' | 'finish' | 'cancel' },
      ) => {
        const { from } = context;
        setCurrentGuideStep(current);
        if (from === 'finish') {
          onFinished();
        } else if (from === 'cancel') {
          onCloseStep();
        }
      }}
      visibleCloseBtn
      hideCancelButton
      showBackButton
      nextButtonTheme="primary"
      backText={formatMessage({id:'guide_last_step'})}
      nextText={formatMessage({id:'guide_next_step'})}
      finishText={formatMessage({id:'guide_more_step'})}
      steps={steps}
    />
  );
};

export default () => {
  const location = useLocation();
  return <>
    {DASHBOARD_GUIDE_BOX_LIST1_PATH === location.pathname && <GuideOverViewDaily />}
  </>
}
